import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ResetPasswordContent } from '@com-delta-idp/mnx-login-ui';
import {
  LoginOAuthParams,
  SelfServicePasswordResetWrapperService,
  UtilService
} from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { BehaviorSubject } from 'rxjs';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { ResetPasswordAdapter } from '../../adapters/reset-password/reset-password.adapters';
import { LoginModalContent } from '../../models/aem';
import {
  LoginContentService,
  LoginModalService,
  NextDisplayViewService,
  PingOauthService,
  ResetPasswordApiService,
  ResetPasswordHelperService
} from '../../services';
import { WifiPortalService } from '../../services/wifi-portal/wifi-portal.service';
import { AddAddressFacadeService } from '../add-address/add-address-facade.service';
import { CheckEmailFacadeService } from '../check-email-facade/check-email-facade.service';
import { CreateMyPasswordFacade } from '../create-my-password/create-my-password.facade';
import { RecoverSQAFacadeService } from '../recover-sqa-facade/recover-sqa-facade.service';
import { RecoverYourAccountFacadeService } from '../recover-your-account-facade/recover-your-account-facade.service';
import { RecoveryOptionsFacade } from '../recovery-options/recovery-options.facade';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordFacadeBaseService {
  resetPasswordadapter = inject(ResetPasswordAdapter);
  resetPasswordhelperService = inject(ResetPasswordHelperService);
  recoveryOptionsFacade = inject(RecoveryOptionsFacade);
  createMyPasswordFacade = inject(CreateMyPasswordFacade);
  checkEmailFacadeService = inject(CheckEmailFacadeService);
  resetPasswordApiService = inject(ResetPasswordApiService);
  wifiPortalService = inject(WifiPortalService);
  loginHelperUtils = inject(LoginHelperUtils);
  nextDisplayViewService = inject(NextDisplayViewService);
  contentService = inject(LoginContentService);
  loggingService = inject(LoggingService);
  recoverSQAFacadeService = inject(RecoverSQAFacadeService);
  addAddressFacadeService = inject(AddAddressFacadeService);
  router = inject(Router);
  pingOauthService = inject(PingOauthService);
  recoverYourAccountFacadeService = inject(RecoverYourAccountFacadeService);
  analytics = inject(AnalyticsService);
  loginModalService = inject(LoginModalService);
  aemContent!: LoginModalContent;
  resetPasswordContent$: BehaviorSubject<ResetPasswordContent | null> =
    new BehaviorSubject<ResetPasswordContent | null>(null);

  selfServicePasswordResetWrapper = inject(
    SelfServicePasswordResetWrapperService
  );

  utils = inject(UtilService);

  isResetPassword = false;
  loginOAuthParams: LoginOAuthParams = {} as LoginOAuthParams;
  pkceCode = this.utils.generateCodeChallenge();
  formSubmit = false;
}
